import { requestApi } from "./axiosHelper"

const rootUrl = process.env.NODE_ENV
  ? process.env.REACT_APP_API_ROOT_URL
  : "http://localhost:8000/api/v1"

const courseEp = rootUrl + "/course"

const courseApi = {
  fetchAllCourses: async (params) => {
    try {
      const axiosData = {
        url: `${courseEp}?${params}`,
        method: "get",
      }
      const data = await requestApi(axiosData, true)
      return data
    } catch (error) {
      return error.response?.data || { status: "error", message: error.message }
    }
  },

  addACourse: async (obj) => {
    try {
      const axiosData = {
        url: `${courseEp}/add`,
        method: "post",
        data: obj,
      }
      const data = await requestApi(axiosData, true)
      return data
    } catch (error) {
      return error.response?.data || { status: "error", message: error.message }
    }
  },
  editACourse: async (obj) => {
    try {
      const axiosData = {
        url: `${courseEp}`,
        method: "put",
        data: obj,
      }
      const data = await requestApi(axiosData, true)
      return data
    } catch (error) {
      return error.response?.data || { status: "error", message: error.message }
    }
  },

  deleteACourse: async (_id) => {
    try {
      const axiosData = {
        url: `${courseEp}/${_id}`,
        method: "delete",
      }
      const data = await requestApi(axiosData, true)
      return data
    } catch (error) {
      return error.response?.data || { status: "error", message: error.message }
    }
  },
}

export default courseApi
